import { jsx as _jsx } from "react/jsx-runtime";
import { visibilityField } from '../_shared/blockFields.js';
import { num, visibilityCss } from '../_shared/blockRender.js';
/**
 * `spacer` — un vide réglable entre deux blocs (feature 0074, lot B).
 *
 * Chaque bloc porte déjà ses marges, mais une marge appartient au bloc qui la porte : pour écarter deux
 * éléments la vendeuse doit deviner lequel des deux régler, et le vide disparaît si elle supprime
 * celui-là. Un espace est une pièce à part, qui se déplace et se supprime comme les autres.
 *
 * Deux hauteurs, bureau et téléphone : 48 px de vide dans une carte de 420 px sur un écran d'ordinateur
 * sont confortables ; sur un téléphone, ils poussent le bouton sous le pli.
 */
export const spacerBlockSchema = {
    type: 'spacer',
    name: 'Spacer',
    fields: [
        visibilityField,
        {
            id: 'height',
            type: 'range',
            label: 'Height',
            min: 0,
            max: 120,
            step: 2,
            default: 16,
            unit: 'px',
        },
        {
            id: 'mobileHeight',
            type: 'range',
            label: 'Height',
            group: 'Mobile',
            min: 0,
            max: 120,
            step: 2,
            default: 12,
            unit: 'px',
        },
    ],
};
const SpacerBlock = ({ block }) => {
    const bs = block.settings;
    const cls = `aqx-sp-${block.id}`;
    const height = num(bs.height, 16);
    const mobile = num(bs.mobileHeight, Math.round(height * 0.75));
    // La hauteur du téléphone est émise dans `@media` ET dans `@container aqx-page`, comme toutes nos
    // règles responsives : la première sert la vraie vitrine, la seconde l'aperçu téléphone de l'éditeur,
    // qui rétrécit le cadre sans changer la fenêtre du navigateur.
    const rule = `.${cls}{block-size:${mobile}px}`;
    const css = `@media(max-width:749px){${rule}}` +
        `@container aqx-page (max-width:749px){${rule}}` +
        visibilityCss(cls, bs.visibility);
    const style = { blockSize: `${height}px`, inlineSize: '100%' };
    return (_jsx("div", { className: cls, style: style, "aria-hidden": "true", children: _jsx("style", { dangerouslySetInnerHTML: { __html: css } }) }));
};
export const spacerBlock = {
    type: 'spacer',
    schema: spacerBlockSchema,
    Component: SpacerBlock,
    meta: { label: 'Spacer', icon: 'space' },
};
//# sourceMappingURL=index.js.map